/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfRegistrationConfigDto } from '../../models/platform-api-result-of-registration-config-dto';

export interface HeadUseraccountsRegistrationConfig$Params {
}

export function headUseraccountsRegistrationConfig(http: HttpClient, rootUrl: string, params?: HeadUseraccountsRegistrationConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfRegistrationConfigDto>> {
  const rb = new RequestBuilder(rootUrl, headUseraccountsRegistrationConfig.PATH, 'head');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfRegistrationConfigDto>;
    })
  );
}

headUseraccountsRegistrationConfig.PATH = '/api/useraccounts/registration-config';
